import { render, staticRenderFns } from "./clock-1.vue?vue&type=template&id=4a3b972c&"
import script from "./clock-1.vue?vue&type=script&lang=js&"
export * from "./clock-1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports